/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningscolumnnet2Inputs */

const en_earningscolumnnet2 = /** @type {(inputs: Earningscolumnnet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earnings`)
};

const de_earningscolumnnet2 = /** @type {(inputs: Earningscolumnnet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einnahmen`)
};

/**
* | output |
* | --- |
* | "Earnings" |
*
* @param {Earningscolumnnet2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningscolumnnet2 = /** @type {((inputs?: Earningscolumnnet2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningscolumnnet2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningscolumnnet2(inputs)
	return de_earningscolumnnet2(inputs)
});
export { earningscolumnnet2 as "earningsColumnNet" }